import { Component, ChangeDetectionStrategy, Input } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { WorkItemMatcher } from '../work-item-matcher'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ElderLabelInputComponent } from '@elderbyte/ngx-starter'
import { MaterialMatcherDetailComponent } from '../material-matcher-detail/material-matcher-detail.component'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-work-item-matcher-detail',
  templateUrl: './work-item-matcher-detail.component.html',
  styleUrls: ['./work-item-matcher-detail.component.scss'],
  imports: [
    MaterialMatcherDetailComponent,
    ElderLabelInputComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class WorkItemMatcherDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _matcher$ = new BehaviorSubject<WorkItemMatcher>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set matcher(matcher: WorkItemMatcher) {
    this._matcher$.next(matcher)
  }

  public get matcher$(): Observable<WorkItemMatcher> {
    return this._matcher$.asObservable()
  }
}
